import React from 'react'

const VCColumn = ({ className, width, children }) => {
  let colClass = 'col'
  if (width !== undefined) {
    switch(width) {
      case '1/2':
        colClass = 'col-lg-6'
        break
      case '1/3':
        colClass = 'col-lg-4'
        break
      case '2/3':
        colClass = 'col-lg-8'
        break
      case '1/4':
        colClass = 'col-lg-3'
        break
      case '2/4':
        colClass = 'col-lg-6'
        break
      case '3/4':
        colClass = 'col-lg-9'
        break
      case '1/6':
        colClass = 'col-lg-2'
        break
      case '2/6':
        colClass = 'col-lg-4'
        break
      case '3/6':
        colClass = 'col-lg-6'
        break
      case '4/6':
        colClass = 'col-lg-8'
        break
      case '5/6':
        colClass = 'col-lg-10'
        break
      default:
        colClass = 'col'
    }
  }
  return (
    <div className={colClass}>
      <div className={className}>
        {children}
      </div>
    </div>
  )
}

export default VCColumn



// WEBPACK FOOTER //
// ./src/components/VCColumn.js